const defaultTipValue = 0;

const getConfigTipValue = (appConfig): number => {
  const configFeatures =
    appConfig.status === 'success' ? appConfig.data.Features : [];

  const configTipRegex = /^default-tip-[1-3]{1}0$/g;
  const configDefaultTipFeatures = configFeatures.filter((feature) =>
    feature.trim().match(configTipRegex),
  );
  const hasConfigTip = configDefaultTipFeatures.length >= 1;

  const tipValue = hasConfigTip
    ? parseInt(configDefaultTipFeatures[0].split('default-tip-')[1])
    : defaultTipValue;

  return tipValue;
};

const getCustomerTipValue = (customer): number =>
  customer.status === 'success'
    ? customer.data.DefaultTipPercentage
    : defaultTipValue;

const getRestaurantTipValue = (tipsConfig): number | undefined => {
  const defaultTipRate = tipsConfig?.Items
    ? tipsConfig.Items.find((tip) => tip.IsDefault)
    : undefined;

  return defaultTipRate
    ? Math.round(defaultTipRate.Percentage * 100)
    : undefined;
};

const getDefaultTipSetting = (tipsConfig, basket): number | undefined => {
  const restaurantTip = getRestaurantTipValue(tipsConfig);

  return basket && typeof basket.tip === 'number' ? basket.tip : restaurantTip;
};

export const checkoutConnectUtils = {
  getConfigTipValue,
  getCustomerTipValue,
  getRestaurantTipValue,
  getDefaultTipSetting,
};
